import { render, staticRenderFns } from "./ImportInviteesFile.vue?vue&type=template&id=0b0d07f4"
import script from "./ImportInviteesFile.vue?vue&type=script&lang=js"
export * from "./ImportInviteesFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports